import {
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
} from "@chakra-ui/react";
import React, { ChangeEvent } from "react";
import { BiSearchAlt2 } from "react-icons/bi";
import { useHasVirtualKeyboard } from "../../../hooks/useHasVirtualKeyboard";

export type SearchBarProps = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  autoFocus?: boolean;
} & InputProps;

export function SearchBar({
  placeholder = "Search...",
  value,
  onChange,
  inputRef,
  autoFocus,
  backgroundColor,
  ...props
}: SearchBarProps) {
  const hasVirtualKeyboard = useHasVirtualKeyboard();

  return (
    <InputGroup {...props}>
      <InputLeftElement pointerEvents="none" color="gray.300">
        <BiSearchAlt2 aria-hidden />
      </InputLeftElement>
      <Input
        backgroundColor={backgroundColor}
        ref={inputRef}
        type="search"
        aria-label="Search"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        autoFocus={autoFocus ? !hasVirtualKeyboard : undefined}
      />
    </InputGroup>
  );
}
